var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 846.98 846.98",
    style: {
      enableBackground: "new 0 0 846.98 846.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#050505;}\n\t.st2{display:inline;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:20;stroke-miterlimit:10;}\n\t.st4{fill:#050505;}\n\t.st5{fill:#232323;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{display:inline;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1264.26,1790.02 1264.26,1841.03 775.46,1841.03 775.46,1269.14 826.47,1269.14 826.47,1790.02  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-385.78,663.23 -874.58,663.23 -874.58,91.34 -630.18,91.34 -597.64,91.34 -385.78,275.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-602.91,280.42 -602.91,86.75 -380.52,280.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-710.64,434.54c0,16.14-5.04,28.48-15.13,37.03c-10.09,8.55-24.43,12.82-43.03,12.82h-13.64v53.34h-31.8 V387.77h47.9c18.19,0,32.02,3.92,41.49,11.74C-715.37,407.34-710.64,419.02-710.64,434.54z M-782.44,458.34h10.46 c9.78,0,17.1-1.93,21.95-5.8c4.86-3.86,7.28-9.49,7.28-16.87c0-7.45-2.04-12.96-6.1-16.51c-4.07-3.55-10.45-5.33-19.13-5.33 h-14.46V458.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-557.9,461.32c0,24.69-7.03,43.6-21.08,56.73c-14.05,13.13-34.35,19.7-60.88,19.7h-42.47V387.77h47.08 c24.48,0,43.49,6.46,57.03,19.39C-564.67,420.08-557.9,438.13-557.9,461.32z M-590.93,462.14c0-32.21-14.22-48.31-42.67-48.31 h-16.92v97.65h13.64C-606.25,511.48-590.93,495.03-590.93,462.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-495.53,537.74h-31.29V387.77h85.96v26.05h-54.67v38.67h50.88v25.95h-50.88V537.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "716.16,532.22 285.89,532.22 285.89,28.8 501.02,28.8 529.66,28.8 716.16,191.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.03,195.24 525.03,24.77 720.79,195.24  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 371.59,
    y: 249.93,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.59,
    y: 309.16,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.59,
    y: 367.82,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.59,
    y: 426.48,
    className: "st5",
    width: 186.78,
    height: 35.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "785.18,463.19 354.91,463.19 354.91,-40.22 570.05,-40.22 598.69,-40.22 785.18,122.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.06,126.21 594.06,-44.26 789.82,126.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440.62,
    y: 180.9,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.62,
    y: 240.13,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.62,
    y: 298.79,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.62,
    y: 357.45,
    className: "st5",
    width: 186.78,
    height: 35.09
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.96,1135.22 -314.31,1135.22 -314.31,631.8 -99.17,631.8 -70.53,631.8 115.96,794.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-75.17,798.24 -75.17,627.77 120.59,798.24  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -228.6,
    y: 852.93,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228.6,
    y: 912.16,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228.6,
    y: 970.82,
    className: "st5",
    width: 263.49,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228.6,
    y: 1029.48,
    className: "st5",
    width: 186.78,
    height: 35.09
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "184.99,1066.19 -245.28,1066.19 -245.28,562.78 -30.14,562.78 -1.51,562.78 184.99,725.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-6.14,729.21 -6.14,558.74 189.62,729.21  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1226.75,
    y: 165.85,
    className: "st3",
    width: 430.27,
    height: 503.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 236.52,
    width: 263.49,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 314.22,
    width: 263.49,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 391.93,
    width: 263.49,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 469.64,
    width: 263.49,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.5,
    y: 547.34,
    width: 263.49,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531.62,
    y: 236.52,
    width: 87.64,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531.62,
    y: 314.22,
    width: 87.64,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531.62,
    y: 391.93,
    width: 87.64,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531.62,
    y: 469.64,
    width: 87.64,
    height: 51.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531.62,
    y: 547.34,
    width: 87.64,
    height: 51.24
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1486.16,742.96 1140.56,676.14 1140.56,172.73 1486.16,95.01  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1414.79,550.73l-63.25-9.99l-52.83-100.84l-46.48,85.16l-40.3-6.37l60.51-112.28L1215.5,301l42.04-6.64 l43.51,81.37l48.01-95.83l59.05-9.33l-79.17,138.51L1414.79,550.73z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "520.76,1422.75 520.76,1821.35 31.96,1821.35 31.96,1249.46 347.47,1249.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "347.47,1422.75 347.47,1249.46 520.76,1422.75  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.27,1592.66c0,16.14-5.04,28.48-15.13,37.03c-10.09,8.55-24.43,12.82-43.03,12.82h-13.64v53.34h-31.8 v-149.97h47.9c18.19,0,32.02,3.92,41.49,11.74C188.54,1565.46,193.27,1577.14,193.27,1592.66z M121.47,1616.46h10.46 c9.78,0,17.1-1.93,21.95-5.8c4.86-3.86,7.28-9.49,7.28-16.87c0-7.45-2.04-12.96-6.1-16.51c-4.07-3.55-10.45-5.33-19.13-5.33 h-14.46V1616.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.01,1619.43c0,24.69-7.03,43.6-21.08,56.73c-14.05,13.13-34.35,19.7-60.88,19.7h-42.47v-149.97h47.08 c24.48,0,43.49,6.46,57.03,19.39C339.24,1578.2,346.01,1596.25,346.01,1619.43z M312.98,1620.26c0-32.21-14.22-48.31-42.67-48.31 h-16.92v97.65h13.64C297.66,1669.6,312.98,1653.15,312.98,1620.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M408.38,1695.86h-31.29v-149.97h85.96v26.05h-54.67v38.67h50.88v25.95h-50.88V1695.86z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1313.29,1393.4 1313.29,1792 824.49,1792 824.49,1220.11 1140,1220.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1140.07,1393.4 1140.07,1220.11 1313.36,1393.4  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 913.58,
    y: 1476.17,
    className: "st5",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 913.58,
    y: 1535.4,
    className: "st5",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 913.58,
    y: 1594.06,
    className: "st5",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 913.58,
    y: 1652.72,
    className: "st5",
    width: 226.55,
    height: 35.09
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1619.26,
    y: 1249.46,
    className: "st7",
    width: 488.8,
    height: 571.89
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1299.68,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1382.98,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1466.28,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1549.59,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1632.89,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1979.4,
    y: 1716.19,
    width: 93.95,
    height: 54.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1299.68,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1382.98,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1466.28,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1549.59,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1632.89,
    width: 93.95,
    height: 54.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1863.08,
    y: 1716.19,
    width: 93.95,
    height: 54.93
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1910.05,1220.11 1910.05,1841.03 1619.26,1821.35 1619.26,1249.46  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1852.93,1629.24 1809.01,1629.24 1764.42,1565.19 1720.29,1629.24 1676.38,1629.24 1742.33,1533.53  1678.2,1441.56 1722.11,1441.56 1764.12,1501.89 1805.66,1441.56 1849.57,1441.56 1786.16,1533.62  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "657.84,323.45 657.84,707.91 189.04,707.91 189.04,156.02 490.41,156.02  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M498.7,136.02H169.04v591.89h508.8V315.17L498.7,136.02z M657.84,707.91h-468.8V156.02h301.37l167.43,167.43 V707.91z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "494.56,319.3 494.56,146.01 667.85,319.3  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.36,489.22c0,16.14-5.04,28.48-15.13,37.03c-10.09,8.55-24.43,12.82-43.03,12.82h-13.64v53.34h-31.8 V442.44h47.9c18.19,0,32.02,3.92,41.49,11.74C335.62,462.02,340.36,473.7,340.36,489.22z M268.55,513.02h10.46 c9.78,0,17.1-1.93,21.95-5.8c4.86-3.86,7.28-9.49,7.28-16.87c0-7.45-2.04-12.96-6.1-16.51c-4.07-3.55-10.45-5.33-19.13-5.33 h-14.46V513.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M493.1,515.99c0,24.69-7.03,43.6-21.08,56.73c-14.05,13.13-34.35,19.7-60.88,19.7h-42.47V442.44h47.08 c24.48,0,43.49,6.46,57.03,19.39C486.33,474.76,493.1,492.81,493.1,515.99z M460.07,516.81c0-32.21-14.22-48.31-42.67-48.31 h-16.92v97.65h13.64C444.75,566.15,460.07,549.71,460.07,516.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M555.46,592.41h-31.29V442.44h85.96v26.05h-54.67v38.67h50.88v25.95h-50.88V592.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "638.33,696.41 638.33,747.42 149.53,747.42 149.53,175.53 200.54,175.53 200.54,696.41  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "677.36,303.93 677.36,688.39 208.56,688.39 208.56,136.5 509.93,136.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M518.22,116.5H188.56v591.89h508.8V295.65L518.22,116.5z M677.36,688.39h-468.8V136.5h301.37l167.43,167.43 V688.39z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "514.14,299.79 514.14,126.5 687.43,299.79  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.65,
    y: 382.56,
    className: "st4",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.65,
    y: 441.79,
    className: "st4",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.65,
    y: 500.45,
    className: "st4",
    width: 319.59,
    height: 35.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.65,
    y: 559.11,
    className: "st4",
    width: 226.55,
    height: 35.09
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.52,
    y: 183.56,
    className: "st6",
    width: 429.97,
    height: 506.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52,163.56v546.46h469.97V163.56H214.52z M664.49,690.02H234.52V183.56h429.97V690.02z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 238.52,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 308.59,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 378.66,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 448.72,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 518.79,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.78,
    y: 588.86,
    width: 84.41,
    height: 46.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 238.52,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 308.59,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 378.66,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 448.72,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 518.79,
    width: 84.41,
    height: 46.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.26,
    y: 588.86,
    width: 84.41,
    height: 46.21
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "453.19,121.5 453.19,742.42 162.4,722.74 162.4,150.85  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "396.07,530.64 352.15,530.64 307.57,466.59 263.44,530.64 219.52,530.64 285.48,434.93  221.34,342.95 265.25,342.95 307.26,403.28 348.8,342.95 392.72,342.95 329.31,435.01  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonDocument);
export default __webpack_public_path__ + "static/media/iconButtonDocument.a3d4ac87.svg";
export { ForwardRef as ReactComponent };